<script setup lang="ts">
import CardOptions from './CardOptions.vue'

const emit = defineEmits<{
  (e: 'edit-label', id: number | null): void
  (e: 'set-main'): void
}>()

const props = defineProps({
  move: { type: Function, default: null },
  remove: { type: Function, default: null },
  push: { type: Function, default: null },
  clean: { type: Function, default: null },
  id: { type: Number, default: null },
  fieldLength: { type: Number, default: 0 },
  section: { type: String, default: '' },
  isMain: { type: Boolean, default: undefined },
})

function handleSetMain() {
  if (props.id == null) return

  // Integração atual: o pai atualiza a propriedade main.
  if (props.isMain !== undefined) {
    if (!props.isMain) emit('set-main')
    return
  }

  // Compatibilidade com usos antigos que dependem da posição.
  if (props.id !== 0) props.move?.(props.id, 0)
}
</script>

<template>
  <CardOptions :id="`edit-data-${props.section}-${props.id}`">
    <v-list density="comfortable" variant="text">
      <v-list-item
        :id="`edit-corporative-account-${props.section}-${props.id}-edit-label-button`"
        @click="emit('edit-label', props.id)"
      >
        <v-list-item-title>
          {{ $t('corporate.edit.editLabelTitle') }}
        </v-list-item-title>
      </v-list-item>

      <v-list-item
        :disabled="props.isMain ?? props.id === 0"
        @click="handleSetMain"
      >
        <v-list-item-title>
          {{ $t('corporate.edit.makeMain') }}
        </v-list-item-title>
      </v-list-item>

      <v-list-item
        class="text-error"
        @click="props.remove && props.remove(props.id)"
      >
        <v-list-item-title>
          {{ $t('general.delete') }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </CardOptions>
</template>
